import { BriefSection } from './exercise';
import { Simulator, SimulatorType } from './simulation';

export enum ExerciseType {
  SelfStudy = 'SelfStudy',
  Classroom = 'Classroom',
}

export interface Timezone {
  id: string;
  name: string;
  offset: string;
}

// @TODO: rename to ScheduledExercise?
export interface Exercise {
  assigned?: boolean;
  adHoc?: boolean;
  brief: BriefSection[]; // From Sanity
  description: string;
  simulationDisabledReason?: string;
  endTime?: Date;
  exercise: {
    name: string;
    state: ExerciseState;
    adHoc: boolean;
  };
  id: string;
  maxNumberOfAttempts?: number;
  simulator: Pick<Simulator, 'id' | 'name' | 'type'>;
  startTime: Date;
  title: string; // Exercise title
  type: ExerciseType;
  visibility: boolean;
}

// For card lists
export type ExerciseSummary = Pick<
  Exercise,
  'adHoc' | 'endTime' | 'id' | 'startTime' | 'title' | 'type' | 'assigned'
> & {
  simulatorType: SimulatorType;
};

export type InstructorExercise = Exercise & {
  exercise: {
    id: string;
    name: string;
  };
  scenario: BriefSection[];
  timeZone: string;
};

export enum ExerciseState {
  Active = 'Active',
  Finished = 'Finished',
}
